import React, { useState } from "react";
import Contacts from "@/pages/contacts";

const Newzealandinvestorvisa = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAnswer = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <div>
        <div className="h-98 relative w-full">
          <img
            src="/newzelands.jpg" // Replace with the correct path to your image
            alt="Canada Immigration"
            className="h-96 w-full object-cover"
          />
         
        </div>
      </div>
      <div className="mt-10  sm:ml-10 md:ml-32 w-full sm:w-2/3 lg:w-3/4 text-center text-2xl sm:text-3xl lg:text-4xl font-bold text-[#011473]  drop-shadow-md">
  New Zealand Investor Visa: A Gateway to Growth and Opportunity
</div>

<div className="flex flex-col items-center space-y-12 py-20 lg:flex-row lg:space-x-8 lg:space-y-0">

{/* Left Section: Image */}
<div className="mb-8 flex justify-center lg:mb-0 lg:w-1/2">
  <img
    src="/newzealandsimg.jpg" // Replace with the correct path to your image
    alt="Canada Skilled Migration Documents"
    className="w-auto h-96 rounded object-cover shadow-lg"
  />
</div>

{/* Right Section: Text */}
<div className="space-y-8 lg:w-1/2">

  {/* Visa Assistance */}
  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 text-blue-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5 13l4 4L19 7"
        />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
      <strong className="text-black">Visa Assistance:</strong> Comprehensive support for all types of visa applications.
    </span>
  </div>

  {/* Documentation Support */}
  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 text-blue-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5 13l4 4L19 7"
        />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
      <strong className="text-black" >Documentation Support:</strong> Step-by-step guidance to meet all document requirements.
    </span>
  </div>

  {/* Expert Consultation */}
  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 text-blue-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5 13l4 4L19 7"
        />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
      <strong className="text-black">Expert Consultation:</strong> Tailored advice for smooth migration processes.
    </span>
  </div>

  {/* Financial Planning */}
  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 text-blue-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5 13l4 4L19 7"
        />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
      <strong className="text-black">Financial Planning:</strong> Assistance in meeting investment or fund requirements.
    </span>
  </div>

  {/* Post-Migration Support */}
  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 text-blue-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5 13l4 4L19 7"
        />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
      <strong className="text-black">Post-Migration Support:</strong> Guidance on settlement and integration.
    </span>
  </div>

</div>
</div>

      
      <div className="">

<p className="mb-5  sm:ml-10 md:ml-32 w-full sm:w-2/3 lg:w-2/3 text-left text-xl sm:text-2xl font-bold text-[#011473] md:text-3xl">
  Key Points for Visa World :
</p>

<div className="ml-4 sm:ml-10 md:ml-32 mb-20 items-left justify-left space-y-4 text-left">
  
  {/** Repeated block structure for each key point */}
  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 text-blue-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5 13l4 4L19 7"
        />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
      <a className="text-black font-bold">Complimentary Assessments:</a> Personalized and confidential evaluations for investment and business opportunities.
    </span>
  </div>

  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 text-blue-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5 13l4 4L19 7"
        />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
    <a className="text-black font-bold">Eligibility Criteria:</a> Includes health certification, biometric verification and police clearance.
    </span>
  </div>

  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 text-blue-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5 13l4 4L19 7"
        />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
    <a className="text-black font-bold">Character Assessment: </a>Ensure compliance with legal and ethical standards.
    </span>
  </div>

  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 text-blue-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5 13l4 4L19 7"
        />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
    <a className="text-black font-bold">Financial Documentation:</a> Submit evidence of business investments (e.g., bank statements).
    </span>
  </div>

  <div className="flex items-center">
    <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-blue-500">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 text-blue-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M5 13l4 4L19 7"
        />
      </svg>
    </div>
    <span className="ml-3 font-medium text-gray-700">
    <a className="text-black font-bold">Seamless Process:</a> Guided and professional approach to business and investment opportunities.
    </span>
  </div>
</div>
</div>




  
     

     
      <Contacts />
    </>
  );
};

export default Newzealandinvestorvisa;
